<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-card class="app-card">
        <v-card-title class="app-card-title mb-0 justify-lg-space-between">
          <p><v-icon>manage_search</v-icon>Detalhamento da Solicitação</p>
        </v-card-title>
        <v-card-text class="app-card-content pl-0 pr-0">
          <v-container>
            <!-- Cabeçalho -->
            <div class="detalhe-header">
              <p><strong class="header-label">NÚMERO: </strong>{{ detalhamento.id }}</p>
              <p><strong class="header-label">TIPO SOLICITAÇÃO: </strong>{{detalhamento.tipoSolicitacao}}</p>
              <p><strong class="header-label">SITUAÇÃO: </strong>{{detalhamento.situacaoSolicitacao}}</p>
            </div>

            <!-- Campos do formulário -->
            <v-row class="detalhe-form">
              <v-col cols="12">
                <v-text-field
                  label="Nome Completo"
                  :value="detalhamento.aluno?.nome"
                  density="compact"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="CPF"
                  :value="FunctionsCommuns.formatCPF(detalhamento.aluno?.cpf)"
                  density="compact"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Data Solicitação"
                  :value="detalhamento?.dataSolicitacao"
                  density="compact"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Motivo"
                  :value="detalhamento?.motivo"
                  density="compact"
                  readonly
                  class="no-pointer-events"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider />

            <!-- Documentos -->
            <v-card-title class="justify-center align-center">
              <span class="text-subtitle-1" style="color: #5f676a"><strong>DOCUMENTOS</strong></span>
            </v-card-title>
            <v-divider/>
            <v-list class="justify-center">
              <v-list-item
                class="detalhe-docs"
                v-for="(documento, index) in detalhamento?.listDocumentos"
                :key="index"
              >
                
                <v-list-item-content  class="justify-center">
                  <v-list-item-title class="doc-title"> 
                    <v-icon size="x-large" color="primary">description</v-icon>
                    {{ documento.tipoDocumento }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="doc-name">{{ documento.nomeArquivo }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="primary" small depressed @click="vizualizarDocumento(documento.urlDownload)">Visualizar</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-divider />

            <!-- Histórico -->
            <v-card-title class="justify-center align-center">
              <span class="text-subtitle-1" style="color: #5f676a"><strong>HISTÓRICO</strong></span>
            </v-card-title>
            <v-divider/>
            <v-container>
              <v-data-table
                :headers="headers"
                :items="items"
                item-key="name"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                class="detalhe-table"
              >
                <template v-slot:column.data-table-header="{ column }">
                  <v-btn @click="sortBy = column.value" :class="{ 'sort-asc': sortBy === column.value && !sortDesc, 'sort-desc': sortBy === column.value && sortDesc }">
                    {{ column.text }}
                    <v-icon v-if="sortBy === column.value">
                      {{ sortDesc ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                    </v-icon>
                  </v-btn>
                </template>
                <template #item.motivo="{ item }">
                  <span class="d-inline-block text-truncate motivo-truncate">
                    {{item.motivo}}
                  </span>
                </template>
                <template #item.dataSolicitacao="{ item }">
                  {{FunctionsCommuns.formatBRDateHora(item.dataSolicitacao)}}
                </template>
              </v-data-table>
            </v-container>
            <v-divider />
            <!-- Botão voltar -->
            <v-row class="justify-end mt-4 mr-4 detalhe-botao">
              <v-btn color="primary" @click="routerList" >
                VOLTAR
              </v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </section>
</template>

<script>
import { throwError } from "rxjs";
import { router } from "@/router";
import { mapActions, mapState } from "vuex";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import EntidadeService from "@/services/sie-pedidos/entidade.service";

export default {
  computed: {
    ...mapState('siePedidos', ['form', 'detalhamento']),
    FunctionsCommuns() {
      return FunctionsCommuns
    }
  },
  mounted() {
    this.getDadosParaSolicitacao();
  },
  data: () => ({
    headers: [
      { text: 'Tipo de Solicitação', value: 'tipoSolicitacao' },
      { text: 'Situação', value: 'situacaoSolicitacao' },
      { text: 'Empresa', value: 'empresaUsuarioSolicitou' },
      { text: 'Usuário', value: 'nomeUsuarioSolicitou' },
      { text: 'Data', value: 'dataSolicitacao' },
    ],
    items: [],
    sortBy: 'dataSolicitacao',
    sortDesc: true,
    loading: false
  }),
  methods: {
    ...mapActions('siePedidos', ['setDetalhamentoSolicitacao']),
    getDadosParaSolicitacao() {
      EntidadeService.getDetalhamentoSolicitacao(router.currentRoute.params.id).subscribe(
        response => {
          this.setDetalhamentoSolicitacao(response.result);
          this.search();
        },
        error => {
          throwError(error);
          this.loading = false;
        }
      );
    },
    vizualizarDocumento(url) {
      window.open(url, '_blank');
    },
    routerList() {
      router.push(`/carteira-macrorregiao/entidade/solicitacoes`);
    },
    search() {
      EntidadeService.getListHistoricoSolicitacao(router.currentRoute.params.id).subscribe(({result})=>{
        this.items = result?.listHistoricoSolicitacao?.map(v=>({...v, tipoSolicitacao: result?.tipoSolicitacao}))
      }, (error)=>{})
    },
  },
}
</script>

<style scoped>
.detalhe-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.header-label {
  color: #0d47a1;
}

.detalhe-form .v-text-field {
  width: 100% !important;
  min-width: 0 !important;
}

.no-pointer-events input {
  pointer-events: none;
  background-color: transparent;
}

.detalhe-docs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.doc-title {
  font-weight: bold;
  word-break: break-word;
}
.doc-name {
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
.v-list-item-action {
  flex: 0 0 auto;
}

.detalhe-docs > * {
  display: flex;
  align-items: center;
}
.detalhe-docs .v-list-item-content {
  flex: 1;
  min-width: 0;
}

.detalhe-table {
  width: 100% !important;
  overflow-x: auto;
  display: block;
}

.sort-asc .v-icon {
  transform: rotate(180deg);
}
.sort-desc .v-icon {
  transform: rotate(0deg);
}

.detalhe-botao {
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .detalhe-header {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .detalhe-docs {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .detalhe-docs .v-list-item-action {
    margin-top: 8px;
  }
  .detalhe-table {
    display: block !important;
    overflow-x: auto !important;
  }
  .detalhe-botao {
    justify-content: center !important;
  }
}
</style>
